import getContentBase from './getContentBase';

export default function expandVttUploadPath(src?: any) {
  let base = getContentBase();
  return !src
    ? ''
    : typeof src === 'string' &&
        (src.startsWith('captions/') || src.startsWith('custom/'))
      ? base + '/' + src
      : String(src);
}
